/**
 * Created by mohit.chavda on 3/7/2017.
 */

export const ONLINE_APP_CONSTANTS  = {
  // Application Key
  APP_KEY : "OnlineApp_",

  FORMAT_PDF : 'pdf',
  FORMAT_DOC :'doc',
  FORMAT_DOCX : 'docx',

  FILE_MIN_SIZE :'minSize',
  FILE_MAX_SIZE : 'maxSize',
  FILE_FORMAT : 'fileFormat',
  PASS : 'PASS',
  DEFAULT_FILE_SIZE_3MB : 3000,
  DEFAULT_FILE_SIZE_5MB : 5000,

  DEFAULT_FILE_SIZE : 0,
  DEFAULT_FILE_SIZE_10MB : 10000,
  DEFAULT_LIVE_DATE : "0000-00-00 00:00:00.0",
  FILE_SIZE_KB : "KB",

  // PROGRAM
  JD_PROGRAM : 1,//"JD Program",
  MLS_PROGRAM : 2,//"MLS Program",
  TIU_PROGRAM: 3, // MATS Program

  // Local Storage Key
  LOCAL_STORAGE_USER_ID: "userId",
  LOCAL_STORAGE_APPLICATION_ID: "applicationId",
  LOCAL_STORAGE_APPLICATION_IS_NEW: "isNewApplication",
  LOCAL_STORAGE_PROGRAM_TRACK: "programTrack",
  LOCAL_STORAGE_ACTIVE_INDEX: "activeIndex",

  // Navigate Key
  NAVIGATE_TO_CONTINUE: "continue",
  NAVIGATE_TO_PREVIOUS: "previous",
  NAVIGATE_TO_SAVE_AND_EXIT: "saveAndExit",
  NAVIGATE_TO_SUBMIT: "submit",

  API_STATUS_200:"T200",

  APPLICANT_STATUS_NEW:{'id':"NEW",'label':"New Student"},
  APPLICANT_STATUS_TRANSFER:{'id':"TRANSFER",'label':"Transfer Student"},

  // Application and Application List
  COM_APPLICATION_LIST : "application",
  JD_SUCCESS_SUBMIT : "../submit-success",
  COM_CONTACT_INFO : "contact",
  COM_PERSONAL_INFO : "demographics",
  COM_BACKGROUND_INFO : "background",
  COM_ADMISSION_STATUS : "admission",
  COM_EDUCATIONAL_BACKGROUND : "education",
  COM_EMPLOYMENT_RECORD : "employment",
  COM_PERSONAL_STATEMENT : "personalStatement",
  COM_FAITH_STATEMENT : "faithStatement",
  COM_STANDARDS_SIGNATURE : "standardsSignature",
  COM_PAYMENT_INFO : "billing",

  //PATH
  ROUTE_PATH_APPLICATION : "/application",
  ROUTE_PATH_APPLICATION_LIST : "/list",

  // JD
  ROUTE_PATH_JD_CONTACT_INFO : "/apply/contact-info",
  ROUTE_PATH_JD_PERSONAL_INFO : "/apply/personal-info",
  ROUTE_PATH_JD_BACKGROUND_INFO : "/apply/background-info",
  ROUTE_PATH_JD_ADMISSION_STATUS : "/apply/admission-info",
  ROUTE_PATH_JD_EDUCATIONAL_BACKGROUND : "/apply/educational-info",
  ROUTE_PATH_JD_EMPLOYMENT_RECORD : "/apply/employment-info",
  ROUTE_PATH_JD_PERSONAL_STATEMENT : "/apply/personal-statement",
  ROUTE_PATH_JD_PAYMENT_INFO : "/apply/payment-info",
  ROUTE_PATH_JD_SUCCESS_SUBMIT : "/apply/submit-success",

  // MLS
  ROUTE_PATH_TIU_CONTACT_INFO : "/apply/tiu-contact-info",
  ROUTE_PATH_TIU_PERSONAL_INFO : "/apply/tiu-personal-info",
  ROUTE_PATH_TIU_BACKGROUND_INFO : "/apply/tiu-background-info",
  ROUTE_PATH_TIU_ADMISSION_STATUS : "/apply/tiu-admission-info",
  ROUTE_PATH_TIU_EDUCATIONAL_BACKGROUND : "/apply/tiu-educational-info",
  ROUTE_PATH_TIU_PERSONAL_STATEMENT : "/apply/tiu-personal-statement",
  ROUTE_PATH_TIU_FAITH_STATEMENT : "/apply/tiu-faith-statement",
  ROUTE_PATH_TIU_STANDARDS_SIGNATURE : "/apply/tiu-standards-signature",
  ROUTE_PATH_TIU_SUCCESS_SUBMIT : "/apply/tiu-submit-success",

  // GENERAL
  SELECT_STATE_DEFAULT:"Select a State",
  SELECT_STATE_NOT_IN_LIST:"Not In List",

  SELECT_COUNTRY_DEFAULT:"Select a Country",
  SELECT_COUNTRY_NOT_IN_LIST:"Not In List",
  PLACE_OF_BIRTH:"PlaceOfBirth",

  // sorting order
  PIPE_SORT_ASCENDING_ORDER : 1,
  PIPE_SORT_DESCENDING_ORDER : -1,

  // Google Analytics Form DataLayer parameter
  EVENT_NAME_FORMSUBMIT: "formSubmit",
  FORM_TYPE_APPLICATION: "TEDS Application",
  DEPARTMENT_TLS: "TLS",
};



// WEBPACK FOOTER //
// ./src/app/common/constant/OnlineAppConstants.ts